import api from './api';

/**
 * Calendar/Activities API
 * Handles user calendar and activity scheduling
 */

/**
 * Get all activities for current user
 * @param {Object} filters - Optional filters (startDate, endDate, status, type)
 * @returns {Promise}
 */
export const getUserActivities = (filters = {}) => {
  const params = new URLSearchParams();
  
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  if (filters.status) params.append('status', filters.status);
  if (filters.type) params.append('type', filters.type);

  return api.get(`/auth/activities?${params.toString()}`);
};

/**
 * Get single activity by ID
 * @param {string} activityId
 * @returns {Promise}
 */
export const getActivityById = (activityId) => {
  return api.get(`/auth/activities/${activityId}`);
};

/**
 * Create new activity
 * @param {Object} activityData
 * @returns {Promise}
 */
export const createActivity = (activityData) => {
  return api.post('/auth/activities', activityData);
};

/**
 * Update activity
 * @param {string} activityId
 * @param {Object} activityData
 * @returns {Promise}
 */
export const updateActivity = (activityId, activityData) => {
  return api.put(`/auth/activities/${activityId}`, activityData);
};

/**
 * Delete activity
 * @param {string} activityId
 * @returns {Promise}
 */
export const deleteActivity = (activityId) => {
  return api.delete(`/auth/activities/${activityId}`);
};

/**
 * Get upcoming activities (next 7 days)
 * @returns {Promise}
 */
export const getUpcomingActivities = () => {
  return api.get('/auth/activities/upcoming');
};

/**
 * Mark activity as complete
 * @param {string} activityId
 * @returns {Promise}
 */
export const markActivityComplete = (activityId) => {
  return api.patch(`/auth/activities/${activityId}/complete`);
};
